import React from "react";
import { Button } from "@mui/material";
import {
  AnswerTypo,
  GridContainer,
  MaskedTypo,
  PopupContainer,
  PopUpHeader,
  QuestionTypo,
} from "./styled";
import "./style.scss";

function PreviewForm({ handleNextStep, previewData }) {
  return (
    <PopupContainer>
      <PopUpHeader>Review Your Input</PopUpHeader>
      <GridContainer>
        {Object.entries(previewData).map(([key, value]) => {
          const displayValue = (() => {
            if (value === null || value === undefined) return "";
            if (typeof value === "object") {
              if (Object.prototype.hasOwnProperty.call(value, "value") && typeof value.value !== "object") {
                return value.value;
              }
              try {
                return JSON.stringify(value);
              } catch (e) {
                return String(value);
              }
            }
            return String(value);
          })();

          const isMask = value && typeof value === "object" && value.isMask;

          return (
            <React.Fragment key={key}>
              <QuestionTypo>{key}</QuestionTypo>:
              <AnswerTypo>{displayValue}</AnswerTypo>
              <MaskedTypo>{isMask ? "Masked" : "UnMasked"}</MaskedTypo>
            </React.Fragment>
          );
        })}
      </GridContainer>
      <div className="button-container">
        <Button
          variant="contained"
          className="btn-yes"
          sx={{ px: 6 }}
          onClick={() => handleNextStep(1)}
        >
          Confirm & Send
        </Button>
        <Button
          className="btn-no"
          variant="outlined"
          sx={{ px: 6 }}
          onClick={() => handleNextStep(-1)}
        >
          Back
        </Button>
      </div>
    </PopupContainer>
  );
}

export default PreviewForm;
